<template>
  <resource-loader :task="task" :resource="modelValue">
    User not found.
  </resource-loader>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { User } from '@/type';
import { HasTaskMixin } from '@/mixins';
import ResourceLoader from '@/components/loading/ResourceLoader.vue';
import repository from './user-repository';

interface Data {
  task: Promise<User>|undefined,
}

export default defineComponent({
  emits: ['loaded', 'update:modelValue'],
  mixins: [HasTaskMixin],
  components: {
    ResourceLoader,
  },
  props: {
    userId: {
      type: Number,
      required: true,
    },
    modelValue: Object as () => User,
  },
  data(): Data {
    return {
      task: undefined,
    };
  },
  watch: {
    userId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
  },
  methods: {
    load() {
      this.task = repository.find(this.userId);
      this.task.then((client) => {
        this.$emit('update:modelValue', client);
        this.$emit('loaded', client);
      });
    },
  },
});
</script>
